const PanelIcon = ({ strokeColor = '#808080' }) => (
<svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 795.1 795.1"
>
<defs>
<style>{`
        .cls-1 {
          fill: #fcfcfc;
        }
        .cls-2 {
          fill: #4d4d4d;
        }
        .cls-3 {
          stroke: ${strokeColor};
          stroke-width: 50px;
        }
        .cls-3, .cls-4 {
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-5 {
          fill: #fbfbfb;
        }
        .cls-4 {
          stroke: #fff;
          stroke-width: 20px;
        }
      `}</style>
</defs>
<g id="Circles">
<circle id="Grey_Bkg" className="cls-2" cx="397.55" cy="397.55" r="388.66" />
<circle id="Grey" className="cls-3" cx="397.55" cy="397.55" r="372.55" />
<circle id="White_Inner" className="cls-4" cx="397.55" cy="397.55" r="343.4" />
</g>
<g id="Shapes">
<g id="Panel">
<g id="Layer_1-2" data-name="Layer 1-2">
<path className="cls-5" d="M568.61,564.41c0,5.6,0,10.43,0,15.27-.04,21.47-9.92,31.64-31.47,31.91-17.3.22-34.61.05-51.92.05-74.06,0-148.13,0-222.19,0-3.05,0-6.12.1-9.16-.14-17.91-1.39-27.38-11.67-27.38-29.68,0-123.18-.01-246.37,0-369.55,0-17.48,9.73-27.86,27.33-28.59,10.67-.45,21.37-.23,32.06-.23,81.7-.03,163.39-.04,245.09-.02,4.07,0,8.14.16,12.2.5,14.36,1.2,24.13,11.03,25.29,25.45.25,3.04.14,6.1.14,9.16,0,115.04,0,230.08,0,345.88M306.66,208.52h-53.78v376.84h289.33V208.51c-78.3,0-156.16,0-235.55,0h0Z"/>
<path className="cls-5" d="M385.33,338.21c-26.7,0-52.64.02-78.58,0-14.32,0-20.7-6.46-20.7-20.87,0-20.34-.02-40.69,0-61.03.01-11.94,5.13-17.63,16.72-17.64,62.81-.09,125.62-.07,188.43.03,10.53.02,16.25,5.98,16.29,16.59.09,21.61.05,43.23.02,64.84-.02,11.68-6.49,18.09-18.43,18.1-34.33.03-68.66-.02-103.75-.04M384.56,263.53h-72.15v48.55h169.24v-47.78c-.55-.37-.76-.64-.98-.64-31.53-.05-63.06-.09-96.11-.13Z"/>
<path className="cls-5" d="M300.92,504.03c-12.42-8.91-16.97-21.77-12.61-34.76,4.03-12,15.65-20.31,28.25-20.19,13.49.13,24.83,8.53,28.24,21.86,2.97,11.59.45,22.32-8.91,30.19-10.51,8.85-22.34,9.38-34.98,2.9M312,484.21c5.01,3,9.07,1.74,10.45-3.74.56-2.23-1.13-6-3.03-7.54-1.41-1.15-6.54-.56-7.01.53-1.27,2.96-.93,6.61-.41,10.75Z"/>
<path className="cls-5" d="M386.89,451.01c13.4-4.18,24.64-1.71,33.44,8.74,7.49,8.9,8.65,19.2,4.77,29.91-4.57,12.62-15.18,18.88-29.94,18.27-12.1-.5-21.87-8.56-25.57-21.07-3.49-11.82,1.03-25.54,10.79-32.35,1.85-1.29,3.97-2.17,6.52-3.49M399.21,485.79c4.84-1.89,7.02-5.56,4.35-10.01-1.19-1.98-6.68-3.91-7.47-3.11-2.23,2.23-3.85,5.84-4.04,9-.08,1.38,3.92,3,7.15,4.12h0Z"/>
<path className="cls-5" d="M484.62,449.79c14,4.05,22.06,13.63,23.05,25.47,1.42,16.94-8.03,26.84-18.02,30.98-10.81,4.48-25.45,1.19-32.79-7.14-8.18-9.28-9.95-23.87-4.21-34.59,6.06-11.3,17.41-16.65,31.96-14.72"/>
<path className="cls-5" d="M312.75,367.84c17.09-.41,30.39,9.57,32.77,23.98,2.45,14.81-6.56,29.3-20.88,33.61-15.26,4.59-32.22-4.5-36.66-19.65-4.6-15.7,4.73-32.53,20.47-36.88,1.22-.34,2.45-.61,4.3-1.06M309.77,397.16c2.43,2.29,4.86,4.58,7.3,6.87,1.89-2.22,4.99-4.29,5.3-6.72.28-2.1-2.6-4.62-4.08-6.95-2.73,1.86-5.45,3.71-8.52,6.8Z"/>
<path className="cls-5" d="M408.48,424.62c-22.07,5.12-39.34-6.35-39.96-25.86-.48-15.32,8.58-26.85,23.94-30.43,12.49-2.91,26.55,4.49,32.25,16.98,5.76,12.63,1.43,27.84-10.41,36.2-1.62,1.14-3.55,1.83-5.82,3.11M391.52,394.71l4.51,9.26c2.5-1.27,6.53-2.07,7.13-3.95.77-2.41-.46-7.38-2.22-8.19-2.23-1.03-5.88,1.03-9.42,2.88h0Z"/>
<path className="cls-5" d="M449.88,389.98c5.35-14.27,16.39-22.7,28.88-22.45,12.2.24,23.56,8.17,27.44,20.2,3.78,11.74,1.63,22.55-7.89,31.04-9,8.03-19.3,10.68-30.68,5.68-11.32-4.98-17.68-13.69-18.17-26.28-.1-2.53.11-5.07.42-8.19M482.45,391.72c-4.77-3.02-8.55-1.58-9.79,3.49-.56,2.27,1.1,5.84,2.92,7.66,1.08,1.08,6.09.54,6.43-.36,1.14-3.04.97-6.56.44-10.8h0Z"/>
<path className="cls-5" d="M410.62,530.82c9,1.08,13.21,5.36,12.85,12.38-.37,7.1-4.48,10.71-12.67,10.78-9.62.09-19.26.1-28.88-.08-7.16-.14-10.3-3.65-10.36-10.97-.07-7.64,3.35-11.9,10.26-12.06,9.37-.21,18.74-.05,28.8-.05h0Z"/>
</g>
<circle className="cls-5" cx="477.71" cy="478.53" r="7.49" />
<circle className="cls-5" cx="398.38" cy="478.83" r="7.49" />
<circle className="cls-5" cx="316.08" cy="478.53" r="7.49" />
<circle className="cls-5" cx="316.34" cy="396.77" r="7.49" />
<circle className="cls-5" cx="397.85" cy="396.77" r="7.49" />
<circle className="cls-5" cx="477.71" cy="396.49" r="7.49" />
</g>
</g>
</svg>
);
 
export default PanelIcon;